import { ActionControllerEventName, ResourcesManager, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import { Mesh, PlaneGeometry, MeshBasicMaterial, Vector3 } from 'three';
import { PickingControllerEvents } from "@verybigthings/vbt-webvr-framework/build/main/ts/controls/PickingController";
import { PreparationPickingObjects } from "../../utils/PreparationPickingObjects";
export default class SerologicalPipetteHolderModule extends ViewerModule {
    constructor(level) {
        super();
        this.__inited = false;
        this.pointerController = Viewer.pointerController;
        this.model = ResourcesManager.getModel('serological_pipette_holder').clone();
        this.addObject(this.model);
        this.level = level;
        const clickingPlane = new Mesh(new PlaneGeometry(3, 3), new MeshBasicMaterial({ visible: false }));
        clickingPlane.userData.improveMaterialIgnore = true;
        clickingPlane.name = 'clickingPlane';
        this.addObject(clickingPlane);
    }
    init() {
    }
    returnToHolder() {
        this.actionController.on(ActionControllerEventName.click, this.uiObject, () => {
            if (!this.level.interaction)
                return;
            if (this.pointerController.currentPointerObject !== this.level.instruments.pipette.uiObject)
                return;
            this.level.instruments.pipette.addToHolder();
            this.actionController.once(ActionControllerEventName.click, this.uiObject, () => {
                if (!this.level.interaction)
                    return;
                this.level.instruments.pipette.addToPointer();
            });
        });
    }
    createClickEvent(clickForHolder = false) {
        let callback;
        this.actionController.on(ActionControllerEventName.click, this.uiObject, callback = () => {
            if (Viewer.controls.zController)
                return;
            if (!this.level.interaction)
                return;
            this.fire('holder_clicked');
            this.actionController.off(ActionControllerEventName.click, this.uiObject, callback);
        });
        if (this.level.lobby.app.zSpacePickingController) {
            const pipetteUiObject = this.level.instruments.pipette.uiObject;
            PreparationPickingObjects.saveObjectState(pipetteUiObject);
            this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.PICKED, pipetteUiObject, () => {
                if (!this.level.interaction)
                    return;
                // PreparationPickingObjects.saveObjectState(pipetteUiObject);
                Viewer.scene.add(pipetteUiObject);
                // pipetteUiObject.traverse(el => {
                //     el.userData.oldRaycast = el.raycast;
                //     el.raycast = () => {};
                // });
                if (!clickForHolder) {
                    this.fire('holder_clicked');
                    this.actionController.off(ActionControllerEventName.click, this.uiObject, callback);
                }
                else {
                    this.level.lobby.app.zSpacePickingController.once(PickingControllerEvents.RELEASED, pipetteUiObject, () => {
                        const distanceToHolder = this.level.instruments.pipette.model.getWorldPosition(new Vector3()).distanceTo(this.model.getWorldPosition(new Vector3()));
                        if (distanceToHolder < 1.8) {
                            this.fire('holder_clicked');
                            this.actionController.off(ActionControllerEventName.click, this.model, callback);
                            this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.PICKED, pipetteUiObject);
                            this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.RELEASED, pipetteUiObject);
                        }
                        else {
                            PreparationPickingObjects.flyObjectToPrevState(pipetteUiObject, 0);
                        }
                        setTimeout(() => pipetteUiObject.traverse(el => {
                            if (el.userData.oldRaycast)
                                el.raycast = el.userData.oldRaycast;
                        }));
                    });
                }
            });
        }
    }
}
